import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImgOverlay, ErrorMessage } from './styles';

const Overlay = ({ item }) => {
  const { t } = useTranslation();
  return (
    <ImgOverlay error={item.error}>
      <ErrorMessage>
        <p>{t(item.error.title)}</p>
        {item.error.subtitle && <p>{t(item.error.subtitle)}</p>}
      </ErrorMessage>
    </ImgOverlay>
  );
};

export default Overlay;
